import { createI18n } from 'vue-i18n'

const DEFAULT_LOCALE = process.env.VUE_APP_I18N_LOCALE || 'es'
const FALLBACK_LOCALE = process.env.VUE_APP_I18N_LOCALE || 'es'

function setupI18n (options) {
  const i18n = createI18n({
    locale: DEFAULT_LOCALE,
    globalInjection: true,
    fallbackLocale: FALLBACK_LOCALE,
    missingWarn: false,
    fallbackWarn: false,
    silentTranslationWarn: true,
    messages: {},
    legacy: false,
    ...options
  })

  return i18n
}

export const i18n = setupI18n()
